module.exports = __webpack_public_path__ + "img/rich1.png";